<span [ngClass]="'display-flex flex-align-center advanced-alert-type type-'+type">
  <span class="advanced-alert-type-text">{{'notification.' + type + '.' + type | translate}}</span>
</span>
